import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { IntegrationForm } from '@/components/integrations/IntegrationForm'
import { PageHeading } from '@/components/layout/PageHeading'

/**
 * Standalone "New integration" page. Editing an existing integration now lives on
 * the integration detail page's Edit tab (`/integrations/:id?tab=edit`); this page
 * only handles creation.
 */
export function IntegrationFormPage() {
  const navigate = useNavigate()

  return (
    <div className="mx-auto max-w-screen-2xl px-6 lg:px-8 py-8">
      {/* Breadcrumb */}
      <div className="flex items-center gap-3 mb-6">
        <button
          onClick={() => navigate('/integrations')}
          className="flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground transition-colors"
        >
          <ArrowLeft className="h-3.5 w-3.5" />
          Integrations
        </button>
        <span className="text-muted-foreground">/</span>
        <span className="text-sm font-medium">New Integration</span>
      </div>

      <PageHeading
        className="mb-6"
        title="New Integration"
        description="Configure the connection and choose whether it routes through the middleware hub or connects directly to the platform. Credentials are stored securely and never shown again after saving."
      />

      <IntegrationForm
        onSaved={() => navigate('/integrations')}
        onCancel={() => navigate('/integrations')}
      />
    </div>
  )
}
